import { Component, HostListener, OnInit } from '@angular/core'
import { AcmSupaDemoDialogService } from '../acm-supa-demo-dialog/acm-supa-demo-dialog.service'
import { AcmSupaDemoService } from '../acm-supa-demo.service'

@Component({
  selector: 'app-acm-supa-demo-btn',
  templateUrl: './acm-supa-demo-btn.component.html',
  styles: [
    `
      :host {
        display: inline-block;
        font-size: 18px;
      }
    `,
  ],
})
export class AcmSupaDemoBtnComponent implements OnInit {
  constructor(private demoDialog: AcmSupaDemoDialogService, private demoService: AcmSupaDemoService) {}

  ngOnInit(): void {}

  @HostListener('click')
  onOpen() {
    const demo = this.demoService.getDemoForCurrentPage()
    if (demo) {
      this.demoDialog.open(demo)
    }
  }
}
